import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms/';

import { FieldType } from '@ngx-formly/core';

import { AuditService } from '@services/audit.service';

import { IScannedAsset } from '@models/types';

import { get, set } from 'lodash-es';

import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const TAG = 'TaProjectSelectComponent';

/**
 * Formly-compatible project select component
 */
@Component({
    selector: 'app-ta-project-select',
    templateUrl: 'ta-project-select.html',
    styleUrls: ['./ta-project-select.scss'],
})
export class TaProjectSelectComponent extends FieldType implements OnInit {

    public projects: IScannedAsset[] = [];

    public dayjs = dayjs;
    public updatedKey: string;

    constructor(
        private auditService: AuditService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        super();
    }

    ngOnInit() {
        const METHOD = 'ngOnInit';

        this.updatedKey = this.key as string;
        if (this.field.parent?.key && this.field.parent?.parent.key) {
            this.updatedKey = this.field.parent?.parent.key + '[' + this.field.parent?.key + '].' + this.key;
        }

        // Get existing projects tag value if it exists
        const projects = get(this.model, this.key, []);
        if (projects) {
            this.projects = projects;
        }
    }

    public async saveProjects(assets: IScannedAsset[]) {
        set(this.model, this.key, assets);
        const formControl = this.formControl as FormControl;
        /* If a projects array has been given, set the formControl value to the array
          else, set the formControl value to null  */

        if (assets) {
            formControl.setValue(assets);
            if (this.props.showInList) {
                const assetsValues = assets.map(asset => asset.value);
                const value = { key: this.updatedKey, label: this.props.label, answer: assetsValues, type: this.field.type as string };
                this.auditService.addShowInListValue(value);
            }

            this.auditService.setLocationAndTimestamp(this.updatedKey);
        } else {
            formControl.reset(null);

            if (this.props.showInList) {
                this.auditService.removeShowInListValue(this.updatedKey as string);
            }

            this.auditService.unsetLocationAndTimestamp(this.updatedKey);
        }

        this.changeDetectorRef.detectChanges();
    }
}
